import axios from "axios";
import React, { useEffect, useState } from "react";
import SkeletonArticle from "../../components/Post_skaliton/SkeletonArticle";
import AuditionsContent from "../../components/Right/AuditionsPost/UpcomingAuditionsContent";

const UpcomingAuditions = () => {
  const [posts, setPosts] = useState([]);
  const [loadingEvent, setLoadingEvent] = useState(true);
  const [paginate, setPaginate] = useState(1);

  useEffect(() => {
    axios.get(`api/user/post/audition/with-paginate/50?page=${paginate}`).then((res) => {
      if (res.data.status === 200) {
        setPosts([...posts, ...res.data.post]);
        setPaginate(paginate + 1);
        setLoadingEvent(false);
      }
    });
  }, []);

  return (
    <center>
    {loadingEvent && [1, 2, 3, 4].map(() => <SkeletonArticle theme="dark" />)}

      {posts.map((event) => (
        <AuditionsContent key={event.id} post={event} />
      ))}
    </center>
  );
};

export default UpcomingAuditions;
